// import { publicPath } from '@/../vue.config'

import pluralize from '@/_core/helpers/pluralize'
import Subject from './Subject'
import VprStartwork from './VprStartwork'
import VprHowto from './VprHowto'
import VprTheme from './VprTheme'

export default class Vpr {
  constructor (data, vprProgress = null) {
    if (!data || !data.id) throw new Error('Invalid VPR data.')

    this.id = data.id

    this.title = data.title ?? ''

    this.imageUrl = data.cover ?? null

    this.author = data.author ?? ''
    this.copyright = data.copyright ?? ''

    this.subject = data.subject ? new Subject(data.subject) : {}

    this.levelFrom = data.level_from ?? 0
    this.levelTo = data.level_to ?? 0

    this.startwork = new VprStartwork(data.startwork)

    this.howto = new VprHowto(data.howto)

    this.controlworks = data.controlworks
      ? data.controlworks
        .sort((prev, next) => prev.id - next.id)
        .map(cwData => new VprTheme(cwData, vprProgress))
      : []

    this.progress = vprProgress

    this._countTasks = data.count_tasks ?? 0
  }

  get countTasks () {
    return this._countTasks || this.controlworks.reduce((acc, theme) => acc + theme.countTasks, 0)
  }

  get countTasksText () {
    return `${this.countTasks} ${pluralize(this.countTasks, 'задание', 'задания', 'заданий')}`
  }

  get levelText () {
    const count = Math.abs(this.levelTo - this.levelFrom) + 1
    const array = Array.from({ length: count }, (_, i) => i + this.levelFrom)
    return array.join(', ')
  }

  findSubthemeById (id) {
    let result = null
    this.controlworks.some(theme => {
      result = theme.findSubthemeById(id)
      return Boolean(result)
    })
    return result
  }

  findTaskById (id) {
    let result = null
    this.controlworks.some(theme => {
      result = theme.findTaskById(id)
      return Boolean(result)
    })
    return result
  }
}
